import { render, staticRenderFns } from "./ButtonMealChangeRequest.vue?vue&type=template&id=17d0c9e0"
import script from "./ButtonMealChangeRequest.vue?vue&type=script&lang=js"
export * from "./ButtonMealChangeRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports